export default __webpack_public_path__ + "static/media/familycouch.dd91f3c9.jpg";